import React from 'react';
import { IntegrationProps } from '../types';

export const WooCommerceSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Store URL</label>
        <input
          type="text"
          value={config.url || ''}
          onChange={(e) => onChange({ url: e.target.value })}
          placeholder="https://mystore.com"
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Consumer Key (CK)</label>
          <input
            type="text"
            value={config.consumerKey || ''}
            onChange={(e) => onChange({ consumerKey: e.target.value })}
            className="w-full p-2 border rounded-lg"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Consumer Secret (CS)</label>
          <input
            type="password"
            value={config.consumerSecret || ''}
            onChange={(e) => onChange({ consumerSecret: e.target.value })}
            className="w-full p-2 border rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};